import React, { forwardRef, memo } from 'react';
import {
  OutlinedInputProps,
  TextField,
  TextFieldProps,
  styled,
} from '@mui/material';
import { BorderAll } from '@mui/icons-material';

const TextFieldCustom = forwardRef<
  any,
  TextFieldProps & {
    register?: any;
  }
>((props, ref) => {
  const { register, onChange, onBlur, ...otherProps } = props;

  return (
    <StyledTextField
      ref={ref}
      {...register}
      {...otherProps}
      onChange={(
        e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
      ) => {
        onChange && onChange(e);
        register?.onChange(e);
      }}
      onBlur={e => {
        onBlur && onBlur(e);
        register?.onBlur(e);
      }}
    />
  );
});

TextFieldCustom.displayName = 'TextFieldCustom';

export default memo(TextFieldCustom);

const StyledTextField = styled(TextField)(({ theme }) => ({
  '& .MuiInputBase-root': {
    borderRadius: 8,
  },
  '& .MuiFilledInput-root': {
    fontWeight: 500,
    overflow: 'hidden',
    borderRadius: 0,
    backgroundColor: 'transparent',
    border: 'none',
    borderBottom: `1px solid ${theme.palette.white[80]}`,
    transition: theme.transitions.create([
      'border-color',
      'background-color',
      'box-shadow',
    ]),
    '&:before': {
      borderBottom: 'unset',
    },
    '&:hover': {
      backgroundColor: 'transparent',
      '&:before': {
        borderBottom: 'unset!important',
      },
      '&:after': {
        borderBottom: 'unset',
      },
    },
    '&.Mui-focused': {
      backgroundColor: 'transparent',
      borderColor: theme.palette.primary.main,
      '&:after': {
        borderBottom: 'unset',
      },
    },
    '&.Mui-readOnly': {
      '&:hover': {
        borderColor: theme.palette.white[80],
        backgroundColor: 'transparent',
        boxShadow: 'unset',
      },
    },
    '&.Mui-error': {
      borderBottomColor: theme.palette.error.main,
    },
  },
}));
